export default __webpack_public_path__ + "images/6ef4cd0248a07362a02de00bdeecc4a8.png";